import type { FileHeader } from "./bus";

type DigesterMeta = Pick<FileHeader, "size" | "name" | "mime">;
type Chunk = ArrayBuffer | Blob;

function chunkLength(chunk: Chunk): number {
  return chunk instanceof Blob ? chunk.size : chunk.byteLength;
}

export class FileDigester {
  private buffer: Chunk[] = [];
  private bytesReceived = 0;
  private readonly size: number;
  private readonly name: string;
  private readonly mime: string;
  private readonly totalSize: number;
  private readonly totalBytesReceived: number;
  private readonly callback: (file: File) => void;
  progress = 0;

  constructor(meta: DigesterMeta, totalSize: number, totalBytesReceived: number, callback: (file: File) => void) {
    this.size = meta.size;
    this.name = meta.name;
    this.mime = meta.mime;
    this.totalSize = totalSize;
    this.totalBytesReceived = totalBytesReceived;
    this.callback = callback;
  }

  unchunk(chunk: Chunk): void {
    this.buffer.push(chunk);
    this.bytesReceived += chunkLength(chunk);
    this.progress = (this.totalBytesReceived + this.bytesReceived) / this.totalSize;
    if (Number.isNaN(this.progress)) this.progress = 1;

    if (this.bytesReceived < this.size) return;

    const blob = new Blob(this.buffer);
    this.buffer = [];
    this.callback(
      new File([blob], this.name, {
        type: this.mime || "application/octet-stream",
        lastModified: Date.now(),
      }),
    );
  }
}
